/** @format */

import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  hideDeleteModal,
  hideExpense,
  toggleRender,
} from "../../../store/stateSlice";
import Popup from "../../global/form create/Popup";
import InputField from "../../inputs/inputField";
import InputTextarea from "../../inputs/inputTextarea";
import price from "../../../Assets/images/price.png";
import InputCalender from "../../inputs/inputCalender";
import HeadTitle from "../../global/HeadTitle";
import { delOne } from "../../../store/helper";
import { Spinner1 } from "../../spinners/Spinner1";
import { Block } from "@mui/icons-material";

const ActionModal = ({ data, type, action, showModal, setShowModal, msg }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const modal = useSelector((state) => state.toggleState.value);

  const types = {
    delete: "حذف",
    block: "حظر",
  };

  return (
    <Popup
      viewPupup={showModal}
      hidePupup={setShowModal}
      viewWidth='content-small'>
      {loading && <Spinner1 />}
      <form className='main-contnt'>
        <div className='head-content'>
          {!!data.image && (
            <img src={data.image} alt='profile-pic' class='img' />
          )}

          <HeadTitle title={msg} />
        </div>
        <div className='body-content'></div>

        <div className='buttons-contnt display-flex center-flex '>
     
          <div class='btn btn__primary' onClick={action}>
            تأكيد
          </div>
          <div class='btn btn__danger' onClick={() => setShowModal(false)}>
            الغاء
          </div>
        </div>
      </form>
    </Popup>
  );
};

export default ActionModal;
